import {card, cardTitle} from "../../assets/jss/material-dashboard-pro-react.jsx";

const styles = {
  card,
  cardTitle,
  description: {
    color: "#999999"
  },
  cardCategory: {
    marginTop: "10px",
    color: "#999999 !important",
    textAlign: "center"
  }
};

export {
  styles
}
